import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/live_discussions/${id}`, payload);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/saveLiveDiscussion.js